export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_ROLES = 'GET_ROLES';